import { render } from "./Configuration.vue?vue&type=template&id=775a4767"
import script from "./Configuration.vue?vue&type=script&lang=js"
export * from "./Configuration.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Configuration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "775a4767"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('775a4767', __exports__)) {
    console.log('reload')
    api.reload('775a4767', __exports__)
  }
  
  module.hot.accept("./Configuration.vue?vue&type=template&id=775a4767", () => {
    console.log('re-render')
    api.rerender('775a4767', render)
  })

}


export default __exports__